/* eslint-disable prettier/prettier */
import { Avatar, Button, Chip, IconButton, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import useAuth from 'hooks/useAuth';
import { useTheme } from '@mui/material/styles';
import { IconEdit, IconTrash } from '@tabler/icons'
import axios from 'axios';
import TweetsyConfig from 'TweetsyConfig';

// eslint-disable-next-line arrow-body-style
const QueueCard = ({ id, index, tweet, dateTimeMS, status, isSingle, texts, setTriggerQueueFetch }) => {
    const theme = useTheme()
    const { twitter } = useAuth();
    const tweetedAtLocal = new Date(dateTimeMS).toString().split(' ').slice(1, -4).join(' ')
    // console.log('time ', dateTimeMS)
    // console.log('time ', tweetedAtLocal)

    const deleteTweet = () => {

        if (isSingle) {
            axios
                // .delete(`http://localhost:5000/tweetThread/${id}/true`)
                .delete(`${TweetsyConfig.getNodeUrl()}tweetThread/${id}/true`)
                .then(res => {
                    console.log("🚀 ~ file: index.js ~ line 21 ~ deleteTweet ~ res", res.data);
                    setTriggerQueueFetch(val => !val)
                }).catch(err => {
                    console.log("🚀 ~ file: index.js ~ line 25 ~ deleteTweet ~ err", err);
                })
        } else {
            console.log(id)
            console.log(index)
            // console.log([...texts.slice(0, index), ...texts.slice(index + 1)])

            axios
                // .delete(`http://localhost:5000/deleteThread/${id}/${index}`)
                .delete(`${TweetsyConfig.getNodeUrl()}deleteThread/${id}/${index}`)
                .then(res => {
                    console.log("🚀 ~ file: index.js ~ line 35 ~ deleteTweet ~ res", res.data);
                    setTriggerQueueFetch(val => !val)
                })


        }

    }



    return (
        <Box
            sx={{
                display: 'flex',
                my: 2,
                mb: isSingle && 5
            }}
        >
            <Avatar alt={twitter.displayName} src={twitter?.photoUrl} />
            <Box
                sx={{
                    ml: 1,
                    border: '1px solid #d2dae2',
                    borderRadius: 1,
                    flexGrow: 1
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        p: 2,
                        pb: '3em',
                        minHeight: '80px'
                    }}
                >
                    {tweet.text}
                    {tweet?.options?.media_data && <Box
                        sx={{
                            // background: 'url(https://pbs.twimg.com/media/FRe7qw2XMAE1xyV?format=jpg&name=small)',
                            background: `url("data:image/png;base64,${tweet?.options?.media_data}")`,
                            objectFit: 'cover',
                            backgroundSize: 'cover',
                            height: '100px',
                            width: '150px',
                            borderRadius: '6px',
                            ml: 2
                        }}
                    />}
                </Box>
                <Box
                    sx={{
                        px: 2,
                        py: 1,
                        borderTop: '1px solid gray',
                        // background: theme.palette.grey[100],
                        // background: '#f2f6f8',
                        background: theme.palette.mode === 'dark' ? '#333c5c' : '#f2f6f8',
                        fontWeight: 500,
                        fontSize: '.9em',
                        borderRadius: '0 0 4px 4px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    <Box>
                        {tweetedAtLocal}
                        {/* <Chip label={tweet.status} /> */}
                        <Chip
                            sx={{
                                ml: 2,
                                background: status === 'POSTED' ? '#e5fceb' : '#fff8e1',
                                color: status === 'POSTED' ? '#00c853' : '#ffc107'
                            }}
                            label={status}
                            size="small"
                        />
                    </Box>

                    <Box sx={{ display: 'flex' }}>
                        {/* <Button
                            variant="outlined"
                            startIcon={<IconEdit />}
                            size="small"
                            sx={{ mr: 1 }}
                        >
                            Edit
                        </Button> */}
                        <Tooltip title="Delete" >
                            <IconButton size='small' color="error" onClick={deleteTweet} >
                                <IconTrash size={20} />
                            </IconButton>
                        </Tooltip>

                    </Box>


                </Box>
            </Box>
        </Box>
    );
};

export default QueueCard;
